import { render, staticRenderFns } from "./FormAttributes.vue?vue&type=template&id=ec9bfa60"
import script from "./FormAttributes.vue?vue&type=script&lang=ts"
export * from "./FormAttributes.vue?vue&type=script&lang=ts"
import style0 from "./FormAttributes.vue?vue&type=style&index=0&id=ec9bfa60&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports